export default "__VITE_ASSET__B6J5BQiK__"